"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tizzano-val-parma": {
    "50ab2664": [{
      "hkey": "da4923cf",
      "slug": "casagalvana",
      "name": "Casagalvana",
      "primary": true,
      "skipSearch": false
    }],
    "casalgavana": [{
      "hkey": "da4923cf",
      "slug": "casagalvana",
      "name": "Casagalvana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "044174e7": [{
      "hkey": "33cfa2ff",
      "slug": "tizzano-val-parma",
      "name": "Tizzano Val Parma",
      "primary": true,
      "skipSearch": false
    }],
    "madurera": [{
      "hkey": "33cfa2ff",
      "slug": "tizzano-val-parma",
      "name": "Tizzano Val Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;